// Rahaty Store — Thank You Page Script
document.addEventListener('DOMContentLoaded', () => {
  // 1. Disable cart drawer trigger interactions on the thank-you page
  document.body.classList.add('cart-disabled');
  const style = document.createElement('style');
  style.textContent = `
    body.cart-disabled [data-cart-drawer-trigger],
    body.cart-disabled cart-drawer-component,
    body.cart-disabled .header-actions__action,
    body.cart-disabled #cart-icon-bubble {
      pointer-events: none !important;
      cursor: not-allowed !important;
      opacity: 0.6 !important;
    }
  `;
  document.head.appendChild(style);

  // 2. Read order details from sessionStorage or test query parameter
  let orderDataRaw = sessionStorage.getItem('rahaty_last_order');
  const waNumber = window.RAHATY_SETTINGS?.whatsappNumber || '13073551993';
  const waBtn = document.getElementById('ty-whatsapp-btn');
  const isAr = document.documentElement.lang === 'ar';

  const urlParams = new URLSearchParams(window.location.search);
  const isTestMode = urlParams.has('test') || window.location.hash.includes('test');

  if (isTestMode) {
    const testOrder = {
      orderId: 'TEST-' + Math.floor(Date.now() / 1000),
      name: isAr ? 'عميل تجريبي' : 'Test Buyer',
      phone: '+971501234567',
      product: 'حزام Belty الأصلي لتخفيف آلام ومغص الدورة الشهرية والظهر',
      totalPrice: '119.95',
      quantity: '1',
      sku: 'RH-BELTY-01'
    };
    orderDataRaw = JSON.stringify(testOrder);
    sessionStorage.setItem('rahaty_last_order', orderDataRaw);
  }
  
  if (orderDataRaw) {
    try {
      const orderData = JSON.parse(orderDataRaw);
      const products = orderData.product ? orderData.product.split('/') : [];
      const quantities = orderData.quantity ? orderData.quantity.split('/') : [];
      
      // Update UI elements
      const nameEl = document.getElementById('ty-customer-name');
      const orderIdEl = document.getElementById('ty-order-id');
      const orderIdWrapper = document.getElementById('ty-order-id-wrapper');
      const summaryCard = document.getElementById('ty-summary-card');
      const fallbackCard = document.getElementById('ty-fallback-card');
      const totalPriceEl = document.getElementById('ty-total-price');
      const itemsListEl = document.getElementById('ty-items-list');

      if (nameEl && orderData.name) {
        const firstName = orderData.name.trim().split(' ')[0];
        nameEl.textContent = isAr ? `شكراً لكِ، ${firstName}! 🎉` : `Thank you, ${firstName}! 🎉`;
      }

      if (orderIdEl) {
        orderIdEl.textContent = isAr ? `رقم الطلب: ${orderData.orderId}` : `Order ID: ${orderData.orderId}`;
        if (orderIdWrapper) orderIdWrapper.classList.remove('hidden');
      }

      if (totalPriceEl) {
        totalPriceEl.textContent = `${orderData.totalPrice} AED`;
      }

      // Guarantee pixel conversion tracking has fired (Snapchat / TikTok / Meta)
      if (window.RahatyPixels && typeof window.RahatyPixels.trackOrderConversion === 'function') {
        window.RahatyPixels.trackOrderConversion(orderData, null, 'thank_you_page', isTestMode);
      } else if (typeof window.firePurchase === 'function') {
        window.firePurchase(orderData, null, isTestMode);
      }

      // Render Line Items
      if (itemsListEl && orderData.items && Array.isArray(orderData.items) && orderData.items.length > 0) {
        itemsListEl.innerHTML = '';
        orderData.items.forEach(item => {
          const vTitle = item.variant_title ? ' (' + item.variant_title + ')' : '';
          const itemRow = document.createElement('div');
          itemRow.className = 'ty-item-row';
          itemRow.innerHTML = `
            <div class="ty-item-row__info">
              <span class="ty-item-row__name">${item.title || ''}${vTitle}</span>
              <span class="ty-item-row__qty">${isAr ? 'الكمية' : 'Qty'}: ${item.quantity || 1}</span>
            </div>
          `;
          itemsListEl.appendChild(itemRow);
        });
      } else if (itemsListEl && products.length > 0) {
        itemsListEl.innerHTML = '';
        products.forEach((name, index) => {
          const qty = quantities[index] || 1;
          const itemRow = document.createElement('div');
          itemRow.className = 'ty-item-row';
          itemRow.innerHTML = `
            <div class="ty-item-row__info">
              <span class="ty-item-row__name">${name}</span>
              <span class="ty-item-row__qty">${isAr ? 'الكمية' : 'Qty'}: ${qty}</span>
            </div>
          `;
          itemsListEl.appendChild(itemRow);
        });
      }

      // Show summary cards, hide fallbacks
      if (summaryCard) summaryCard.classList.remove('hidden');
      if (fallbackCard) fallbackCard.classList.add('hidden');

      // If in test mode, display helpful indicator
      if (isTestMode && summaryCard) {
        const testNotice = document.createElement('div');
        testNotice.style.cssText = 'background: #ecfdf5; border: 1px solid #10b981; color: #065f46; padding: 12px 16px; border-radius: 8px; margin-bottom: 14px; text-align: center; font-size: 13px; font-weight: 600; line-height: 1.5;';
        testNotice.innerHTML = isAr 
          ? '✅ <strong>وضع الاختبار نشط:</strong> تم إرسال حدث الشراء (Purchase) إلى <strong>Snapchat</strong> و<strong>TikTok</strong> و<strong>Meta</strong>! جاري توجيهك إلى واتساب...' 
          : '✅ <strong>Test Mode Active:</strong> Purchase event successfully fired to <strong>Snapchat</strong>, <strong>TikTok</strong>, and <strong>Meta</strong>! Redirecting to WhatsApp...';
        summaryCard.insertBefore(testNotice, summaryCard.firstChild);
      }

      // Format WhatsApp message
      let productsFormatted = '';
      if (orderData.items && Array.isArray(orderData.items) && orderData.items.length > 0) {
        orderData.items.forEach(item => {
          const vTitle = item.variant_title ? ' (' + item.variant_title + ')' : '';
          const qty = item.quantity || 1;
          productsFormatted += `- ${(item.title || '').trim()}${vTitle} × ${qty}\n`;
        });
      } else {
        products.forEach((name, index) => {
          const qty = quantities[index] || 1;
          productsFormatted += `- ${name.trim()} × ${qty}\n`;
        });
      }
      const totalDisplay = orderData.totalPrice || '0.00';

      const waMsg = isAr 
        ? `السلام عليكم\nالمرجو حجز منتجي و تأكيد طلبي في اسرع وقت ممكن.\n\n*المنتجات المطلوبة:*\n${productsFormatted}\n*المبلغ الإجمالي:* ${totalDisplay} درهم` 
        : `Hello\nPlease reserve my item and confirm my order as soon as possible.\n\n*Requested Products:*\n${productsFormatted}\n*Total Amount:* ${totalDisplay} AED`;

      const targetWaUrl = `https://wa.me/${waNumber}?text=${encodeURIComponent(waMsg)}`;

      if (waBtn) {
        waBtn.href = targetWaUrl;
      }

      // Automatically redirect to WhatsApp with a 4-second countdown
      scheduleWhatsAppRedirect(targetWaUrl, isAr, waBtn);

      // Filter purchased products from Cross-Sell section
      if (products.length > 0) {
        const purchasedNames = products.map(name => name.trim().toLowerCase());
        document.querySelectorAll('.ty-cross-card').forEach(card => {
          const cardTitle = card.getAttribute('data-product-title')?.trim().toLowerCase();
          if (cardTitle && purchasedNames.includes(cardTitle)) {
            card.remove();
          }
        });
      }

    } catch (e) {
      console.error('Error parsing thank-you order data:', e);
      setupFallbackWhatsApp(waBtn, waNumber, isAr);
    }
  } else {
    // No sessionStorage found - user refreshed or navigated manually
    setupFallbackWhatsApp(waBtn, waNumber, isAr);
  }
});

function scheduleWhatsAppRedirect(targetUrl, isAr, btn) {
  let redirectSeconds = 4;
  const countdownEl = document.getElementById('ty-wa-countdown');
  
  if (countdownEl) {
    countdownEl.innerHTML = isAr 
      ? `⚡ جاري تحويلك تلقائياً لتأكيد الطلب عبر واتساب خلال <strong id="ty-timer-count">${redirectSeconds}</strong> ثوانٍ...` 
      : `⚡ Automatically redirecting to WhatsApp to confirm order in <strong id="ty-timer-count">${redirectSeconds}</strong>s...`;
    countdownEl.style.display = 'block';
  }

  let redirected = false;
  if (btn) {
    btn.addEventListener('click', () => {
      redirected = true;
    });
  }

  const countdownInterval = setInterval(() => {
    redirectSeconds--;
    const timerCountEl = document.getElementById('ty-timer-count');
    if (timerCountEl) {
      timerCountEl.textContent = redirectSeconds;
    }
    if (redirectSeconds <= 0) {
      clearInterval(countdownInterval);
      if (!redirected) {
        redirected = true;
        window.location.href = targetUrl;
      }
    }
  }, 1000);
}

function setupFallbackWhatsApp(btn, number, isAr) {
  const waMsg = isAr 
    ? `السلام عليكم\nالمرجو حجز منتجي و تأكيد طلبي في اسرع وقت ممكن.`
    : `Hello\nPlease reserve my item and confirm my order as soon as possible.`;
  const targetWaUrl = `https://wa.me/${number}?text=${encodeURIComponent(waMsg)}`;
  
  if (btn) {
    btn.href = targetWaUrl;
  }

  // Also auto-redirect fallback after countdown
  scheduleWhatsAppRedirect(targetWaUrl, isAr, btn);

  const fallbackCard = document.getElementById('ty-fallback-card');
  if (fallbackCard && !fallbackCard.querySelector('.ty-test-helper')) {
    const testBox = document.createElement('div');
    testBox.className = 'ty-test-helper';
    testBox.style.cssText = 'margin-top: 18px; padding: 14px; background: #f8fafc; border: 1px dashed #cbd5e1; border-radius: 8px; text-align: center; font-size: 13px;';
    testBox.innerHTML = `
      <p style="margin: 0 0 8px 0; color: #475569; font-weight: 500;">
        ${isAr ? 'هل ترغب باختبار بكسلات الشراء (Snapchat / TikTok / Meta)؟' : 'Testing conversion pixels (Snapchat / TikTok / Meta)?'}
      </p>
      <a href="?test=1" style="display: inline-block; padding: 7px 16px; background: #000; color: #fff; border-radius: 6px; text-decoration: none; font-size: 12px; font-weight: 600;">
        ⚡ ${isAr ? 'إرسال حدث شراء تجريبي فوري' : 'Fire Test Purchase Event'}
      </a>
    `;
    fallbackCard.appendChild(testBox);
  }
}
